import React from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

/*
 This slides two or more items (Slide elements) in horizontally.
 Slide elements are inside TransitionGroup which must have defined height.
*/

export class TransitionItem extends React.PureComponent {
  render() {
    const { children, reversed, ...props } = this.props;

    if (!props.classNames) {
      props.classNames = reversed ? 'a-slide-reversed' : 'a-slide';
    }

    return (
      <CSSTransition {...props} timeout={750}>
        <div className="a-slide__item">
          <div className="a-slide__height">
            {children}
          </div>
        </div>
      </CSSTransition>
    );
  }
}

export const reversedAnimationChildFactory = (reversed) => (child) =>
  React.cloneElement(child, {
    classNames: reversed ? 'a-slide-reversed' : 'a-slide'
  });

// eslint-disable-next-line react/no-multi-comp
export class TransitionGroupMode extends React.PureComponent {
  render() {
    const { height, mode, reversed } = this.props;

    return (
      <TransitionGroup
        childFactory={reversedAnimationChildFactory(reversed)}
        className={`a-slide__wrapper a-slide--${mode}`}
        style={{ height }}
      >
        {this.props.children}
      </TransitionGroup>
    );
  }
}



// WEBPACK FOOTER //
// ./app/Assets/js/features/components/transitions/Slide.js